import { BackBoneResponseDTO } from "@models/dto/backbone.dto";

export enum VisitDbSyncTaskStatus {
    Downloaded = 'downloaded',
    NotDownloaded = 'not_downloaded',
    Downloading = 'downloading',
    DownloadFailed = 'download_failed',
    InDownLoadQueue = 'in_download_queue',
    Uploading = 'uploading',
    UploadFailed = 'upload_failed',
    Uploaded = 'uploaded',
    InUpLoadQueue = 'in_upload_queue',
    None = 'none',
}


export interface BackboneTable extends BackBoneResponseDTO {
    userName: string;
    lastSyncDate: Date | null;
    lastSyncFailedReason?: string;

    /**
     * Primary key {username + visit_no}
     */
    seq : string;
    syncStatus : VisitDbSyncTaskStatus
}

export type VisitUpSyncInfoTable = {
    orderNum: number;
    upSync: boolean;
    tableName: string;
    visitNo: string;
    userName: string;
    /**
     * primary key {username + visitNo + tableName}
     */
    seq : string;
};

export type AppSettingsTable<T = any> = {
    key : string,
    value : T
}